var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _c("div", { staticClass: "mb-4" }, [
                _c("h4", { staticClass: "grey--text darken-4 mb-0" }, [
                  _vm._v(
                    "\n          Status de escoamento por períodos:\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.periods, function (period, index) {
                return _c("div", { key: index, staticClass: "period-item" }, [
                  _c("div", { staticClass: "d-flex align-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "period-icon-wrapper mr-3",
                        class: _vm.getPeriodIconWrapperClass(period.status),
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            class: _vm.getPeriodIconClass(period.status),
                            attrs: { size: "16" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.getPeriodIcon(period.status)) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c(
                        "div",
                        { staticClass: "period-date font-weight-bold" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatPeriodDate(period.startDate)) +
                              " à " +
                              _vm._s(_vm.formatPeriodDate(period.endDate)) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      period.status === "confirmed"
                        ? _c("div", { staticClass: "period-status" }, [
                            _vm._v(
                              "\n              Confirmado: " +
                                _vm._s(
                                  _vm.formatDateTime(period.confirmedDate)
                                ) +
                                "\n            "
                            ),
                          ])
                        : _c("div", { staticClass: "period-status" }, [
                            _vm._v("\n              Pendente\n            "),
                          ]),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }